import { render, staticRenderFns } from "./orderProductionPreview.vue?vue&type=template&id=d1937488&scoped=true&"
import script from "./orderProductionPreview.vue?vue&type=script&lang=js&"
export * from "./orderProductionPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1937488",
  null
  
)

export default component.exports